import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';

import CustomDropdown from 'components/CustomDropdown';

export const CategoryHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 2,
  backgroundColor: theme.palette.background.main,
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  maxHeight: '74px',
}));

export const SmallCustomDropdown = styled(CustomDropdown)(({ theme }) => ({
  '.MuiSelect-select': {
    padding: `${theme.spacing(0.5)} ${theme.spacing(1.25)}`,
  },
}));

export const CustomBox = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(0, 1, 2, 1),
}));
